export default __webpack_public_path__ + "static/latest-5-13f7b098dff652f5714a8ffce5143cc2.webp";